import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, input, Input, NgModule, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { LaunchDarklyService } from '../../../core/services/launchdarkly.service';
import * as TakeOff from '../core/index';

export type PitchChangedEventArgs = {
    degrees: number;
    ratio: string;
};

@Component({
    selector: 'app-take-off-pitch-dropdown',
    templateUrl: './pitch-dropdown.component.html',
    styleUrls: ['./pitch-dropdown.component.scss', '../../../shared/composable-styles/button.scss'],
    standalone: false,
})
export class TakeOffPitchDropdownComponent implements OnChanges {
    @Input() degrees = 0;
    @Input() ratio = '';
    @Input() disabled = false;
    isHeader = input<boolean>(false);
    @Output() pitchChanged: EventEmitter<PitchChangedEventArgs> = new EventEmitter<PitchChangedEventArgs>();

    readonly #launchDarklyService = inject(LaunchDarklyService);
    isNewView = this.#launchDarklyService.get('takeoffs-ui-uplift') ?? false;

    // @ts-ignore TS2322
    ratioX: string = null;
    // @ts-ignore TS2322
    ratioY: string = null;
    // @ts-ignore TS2322
    ratioError: string = null;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.ratio) {
            const newRatio = changes.ratio.currentValue;
            if (TakeOff.PitchFactors.isValidRatio(newRatio)) {
                this.ratioX = newRatio.split(':')[0];
                this.ratioY = newRatio.split(':')[1];
            } else {
                // @ts-ignore TS2322
                this.ratioX = null;
                // @ts-ignore TS2322
                this.ratioY = null;
            }
        }
    }

    onDegreesChanged = () => {
        this.degrees = this.degrees || 0;
        // @ts-ignore TS2322
        this.ratioX = null;
        // @ts-ignore TS2322
        this.ratioY = null;
        // @ts-ignore TS2322
        this.pitchChanged.emit({ degrees: this.degrees, ratio: null });
    };

    onRatioXYChanged = () => {
        if (!this.ratioX && !this.ratioY) {
            this.ratioError = '';
            return;
        }
        this.ratio = `${this.ratioX}:${this.ratioY}`;
        if (!TakeOff.PitchFactors.isValidRatio(this.ratio)) {
            this.ratioError = 'Rise & run must be 2 whole numbers.';
        } else {
            this.ratioError = '';
            this.degrees = TakeOff.PitchFactors.ratioToDegrees(this.ratio);
            this.pitchChanged.emit({ degrees: this.degrees, ratio: this.ratio });
        }
    };
}

@NgModule({
    declarations: [TakeOffPitchDropdownComponent],
    imports: [CommonModule, FormsModule, TooltipModule, PopoverModule],
    exports: [TakeOffPitchDropdownComponent],
})
export class TakeOffPitchDropdownModule {}
